import { apiPost, apiStore } from '../../../modules/apiHelper';
import { toBoolean } from '../../../modules/dataHelper';

export default {
  // this relies on the license module for ementored users
  // and mentee userdata for company scope users // TODO
  async getMenteeGoalGroup(context) {
    const menteeId = context.rootState.User.id;
    const mentee = await context.dispatch('getUserData', menteeId);
    const isMainApp = (await context.dispatch('evaluateScope'))[1];

    const menteeGoalGroupId = isMainApp
      ? context.rootGetters.menteeGoalGroupId // main app is controlled by the license/packages system
      : mentee.professionid; // scope apps are controlled by the mentee category during signup
    //

    const pillars = await context.dispatch('getPillarGroups', []);

    return pillars.find(p => Number(p.id) === Number(menteeGoalGroupId));
  },
  async updateMenteeGoals(context, newGoals = []) {
    const removeGoalsPromises = [];
    const addGoalsPromises = [];
    // eslint-disable-next-line no-var
    var hasErrors = false;

    // removing unselected goals
    context.state.goals.forEach((goalid) => {
      const menteeGoalExist = newGoals.find(newGoalid => newGoalid === goalid);

      if (!menteeGoalExist) {
        const formData = new FormData();
        formData.set('subid', goalid);
        formData.set('userid', context.rootState.User.id);

        const promise = apiPost('del_mentee_goal', formData, 1)
          .catch((err) => {
            hasErrors = true;
            console.warn('Cannot remove goal ', goalid, '\n', err);
          })
          .then((res) => {
            if (!res) return false;
            if (toBoolean(res.data.error)) {
              console.warn('Error in removing goal \n', res.data.message);
              return false;
            }

            context.commit('removeMenteeGoal', goalid);
            return true;
          });

        removeGoalsPromises.push(promise);
      }
    });

    await Promise.all(removeGoalsPromises);

    // adding selected goals
    newGoals.forEach((goalid) => {
      const menteeGoalExist = context.getters.getMenteeGoal(goalid);

      if (!menteeGoalExist) {
        const formData = new FormData();
        formData.set('subid', goalid);
        formData.set('userid', context.rootState.User.id);
        formData.set('type', 1); // ? meaning?
        const promise = apiPost('add_mentee_goal', formData, 1)
          .catch((err) => {
            hasErrors = true;
            console.warn('Could not create mentor goal \n', err);
          })
          .then((res) => {
            if (!res) return false;
            if (toBoolean(res.data.error)) {
              console.warn('Error in adding mentee goal \n', res.data.message);
              return false;
            }

            context.commit('addMenteeGoal', goalid);
            return true;
          });

        addGoalsPromises.push(promise);
      }
    });

    const addGoalsResponse = await Promise.all(addGoalsPromises)
      .then(async () => {
        if (hasErrors) {
          await context.dispatch('getUserGoals')
            .then((res) => {
              if (!res) return false;
              if (toBoolean(res.data.error)) {
                return false;
              }

              const userGoals = res.data.goals_check || [];

              userGoals.forEach((goal) => {
                context.commit('addMenteeGoal', goal.ementid);
              });

              return true;
            });
        }
        await apiStore.setItem('menteegoals', context.state.goals);
      });

    return addGoalsResponse;
  },
};
